import reggieNoDisc from "../../assets/Reggie-Charging.svg";

const Maintenance = () => {
    return (
        <div className="relative z-0 flex h-full w-full overflow-hidden">
            <div className="relative flex h-full max-w-full flex-1 flex-col overflow-hidden">
                <main className={"relative h-full w-full flex-1 overflow-auto transition-width"}>
                    <div role="presentation" tabIndex={0} className="flex h-full flex-col focus-visible:outline-0">
                        <div className="flex-1 overflow-hidden">
                            <div className="flex items-center justify-center h-full">
                                <div className="flex h-full flex-col items-center justify-center max-w-2xl m-4">
                                    <img src={reggieNoDisc} alt="Reggie" className="h-[190px]" />
                                    <div className="text-j-green text-4xl mt-3 text-center">Reggie's recharging!</div>
                                    <div className="text-j-dark text-2xl mt-3 text-center">
                                        Our regulatory assistant is taking a quick maintenance break. Please try again later.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default Maintenance;
